import { MDBTextArea } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMisc } from "../../../apiclients/streamsapi_bridge";

function StreamTeamGeneralSettings({ register, errors, watch, setValue }) {
  const { t, i18n } = useTranslation();
  const [teamTypes, setTeamTypes] = useState({});
  const [accessibilityList, setAccessibilityList] = useState({});
  const [displayAccessibilities, setDisplayAccessibilities] = useState({});

  useEffect(() => {
    fetchStreamsTeamMisc();
  }, []);

  useEffect(() => {
    if (watch("team_type")) {
      if (parseInt(watch("team_type")) === 4) {
        const updatedJSON = removeKeyValuePair(accessibilityList, 1);
        setDisplayAccessibilities(updatedJSON);
        // Check if the current accessibility value is "Automatic" and update it to "Only Admin can Invite"
        if (parseInt(watch("accessibility")) === 1) {
          setValue("accessibility", 2, { shouldDirty: true });
        }
      } else {
        setDisplayAccessibilities(accessibilityList);
      }
    }
  }, [watch("team_type")]);

  const removeKeyValuePair = (jsonObject, valueToRemove) => {
    const newObj = { ...jsonObject };
    for (const key in newObj) {
      if (newObj.hasOwnProperty(key) && newObj[key] === valueToRemove) {
        delete newObj[key];
        break; // Assuming the value is unique, so once found and removed, we exit the loop
      }
    }
    return newObj;
  };

  async function fetchStreamsTeamMisc() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["create_team"],
      };

      const serverResponse = await getMisc(siteid, params);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const responseData = await serverResponse.json();
        console.log("Response Data:", JSON.stringify(responseData));
        setTeamTypes(responseData?.misc?.streams_teams?.team_types || {});
        setAccessibilityList(
          responseData?.misc?.streams_teams?.accessibility || {}
        );
        setDisplayAccessibilities(
          responseData?.misc?.streams_teams?.accessibility || {}
        );
      }
    } catch (error) {
      console.error("[fetchAddLocationMisk] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  return (
    <>
      <div className="vtabHeight pt-1">
        <div className="w-75">
          <div className="general-settings">{t("general")}</div>
          <div className="ps-2">
            <div className="add-numbermain">
              <div>{t("name")}</div>
              <div className="w-30">
                <input
                  type="text"
                  maxLength={32}
                  className="form-control  selectname w-100"
                  {...register("team_name", {
                    required: "Name is required",
                  })}
                />
                {errors.team_name && (
                  <p className="text-danger">{errors.team_name.message}</p>
                )}
              </div>
            </div>
            <div className="add-numbermain">
              <div>{t("Type")}</div>
              <div className="d-flex w-30">
                <select
                  className="form-control form-select selectname"
                  name="Private"
                  value={parseInt(watch("team_type"))}
                  onChange={(e) =>
                    setValue("team_type", parseInt(e.target.value), {
                      shouldDirty: true,
                    })
                  }
                >
                  {Object.entries(teamTypes).map(([value, key]) => (
                    <option key={parseInt(key)} value={parseInt(key)}>
                      {value}
                    </option>
                  ))}
                </select>
                {errors.team_type && (
                  <p className="text-danger">{errors.team_type.message}</p>
                )}
              </div>
            </div>

            <div className="add-numbermain">
              <div>{t("Accessibility")}</div>
              <div className="d-flex w-30">
                <select
                  className="form-control form-select selectname"
                  name="Private"
                  value={parseInt(watch("accessibility"))}
                  onChange={(e) =>
                    setValue("accessibility", parseInt(e.target.value), {
                      shouldDirty: true,
                    })
                  }
                >
                  {Object.entries(displayAccessibilities).map(
                    ([key, value]) => (
                      <option key={parseInt(value)} value={parseInt(value)}>
                        {key}
                      </option>
                    )
                  )}
                </select>
                {errors.accessibility && (
                  <p className="text-danger">{errors.accessibility.message}</p>
                )}
              </div>
            </div>

            <div className="add-numbermain">
              <div>{t("EnableContributor")}</div>
              <div>
                <label className="switch">
                  <input
                    className="form-control"
                    {...register("enable_contributor")}
                    type="checkbox"
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className="add-numbermain">
              <div>{t("HideTeamMembers")}</div>
              <div>
                <label className="switch">
                  <input
                    className="form-control"
                    {...register("hide_team_members")}
                    type="checkbox"
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className="add-numbermain">
              <div>{t("Description")}</div>
              <div className="d-flex w-30">
                <MDBTextArea
                  value={watch("description")}
                  onChange={(e) =>
                    setValue("description", e.target.value, {
                      shouldDirty: true,
                    })
                  }
                  rows={3}
                />
                {errors.description && (
                  <p className="text-danger">{errors.description.message}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StreamTeamGeneralSettings;
